import { useMutation } from 'react-query';
import { companyType, CompanyTypeParams } from '~/api/companyType';
import { CompanyTypeReq } from '~/types/CompanyType';
import { useUpdateGetApplicationCache } from './wizard';

export const useCompanyTypeMutation = () => {
  const updateCache = useUpdateGetApplicationCache();

  return useMutation(
    ({ data, params }: { data: CompanyTypeReq; params?: CompanyTypeParams }) => companyType(data, params),
    {
      onSuccess(res) {
        updateCache(res);
      },
    },
  );
};
